/*
                                            ┌─state───────────────────────────────┐                 ┌─────────┐┌─────────┐┌─────────┐
                                            │                                     │                 │  tab 1  ││  tab 2  ││  tab 3  │
                                            │  pdf1:{ content: '', id: '' }       │                 └─────────┘└─────────┘└─────────┘
                                            │                                     │                      ╱          ╲          ╲
                                            │  pdf2:{ content: '', id: '' }       │                     ╱            ╲          ╲
                                            │                                     │                    ╱              ╲          ╲
                                            │  pdf3:{ content: '', id: '' }       │                   ╱                ╲          ╲
                                            │                                     │                  ╱                  ╲          ╲
                                            └─────────────────────────────────────┘          ╱──────╱                   │           ╲──────────────────────╲
                                                                                          ╱                               ╲                                   ╲
                                                                                        ▼                                   ▼                                   ▼
                                                                       ┌─────────────────────────────────┐ ┌─────────────────────────────────┐ ┌─────────────────────────────────┐
 ┌────────────────────┐                                                │                  ┌ ─ ─ ─ ─ ─ ─  │ │                  ┌ ─ ─ ─ ─ ─ ─  │ │                  ┌ ─ ─ ─ ─ ─ ─  │
 │successfully upload │◀───────────────────────────────────────────────┼──────────────────    upload   │ │ │                      upload   │ │ │                      upload   │ │
 └────────────────────┘                                                │                  └ ─ ─ ─ ─ ─ ─  │ │                  └ ─ ─ ─ ─ ─ ─  │ │                  └ ─ ─ ─ ─ ─ ─  │
            │                                                          │  ┌ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │ │  ┌ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │ │  ┌ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │
            ▼                                                          │  │                              │ │  │                              │ │  │                              │
┌──────────────────────┐                                               │                               │ │ │                               │ │ │                               │ │
│setState: change pdf's│                                               │  │                              │ │  │                              │ │  │                              │
│         'id'         │          ┌──────────────────────┐             │                               │ │ │                               │ │ │                               │ │
└──────────────────────┘          │setState: change pdf's│             │  │                              │ │  │                              │ │  │                              │
            │               ┌────▶│      'content'       │──update view┼─▶            pdf 1            │ │ │              pdf 2            │ │ │              pdf 3            │ │
            ▼               │     └──────────────────────┘             │  │                              │ │  │                              │ │  │                              │
┌──────────────────────┐    │                                          │                               │ │ │                               │ │ │                               │ │
│useEffect on pdf1/2/3:│    │                                          │  │                              │ │  │                              │ │  │                              │
│  fetch from server   │────┘                                          │                               │ │ │                               │ │ │                               │ │
└──────────────────────┘                                               │  │                              │ │  │                              │ │  │                              │
                                                                       │  └ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │ │  └ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │ │  └ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─ ─  │
                                                                       └─────────────────────────────────┘ └─────────────────────────────────┘ └─────────────────────────────────┘
*/
import React, { useCallback, useEffect, useState } from 'react';
import { Tabs } from 'antd';
// import '@style/modules/project/userGuideSetting.scss';
import '../../../styles/modules/project/userGuideSetting.scss';
import PDFViewControl from '@modules/systemSetting/userGuideSetting/pdfViewControl';
import { API } from '@service';
import { useHistory } from 'react-router-dom';
import { getValueFromSearchParam, setURLSearchParam } from '@utils/history';

const { TabPane } = Tabs;

function UserGuideSetting(props) {
  const stateInitial = { contentBlob: '', fileName: '' };
  const [pdfInternal, setPdfInternal] = useState(stateInitial);
  const [pdfClient, setPdfClient] = useState(stateInitial);
  const [pdfShared, setPdfShared] = useState(stateInitial);
  const history = useHistory();
  const { tab: defaultTab = 'internal' } = getValueFromSearchParam('tab');

  function fulfullPDFIfExist(type, callback) {
    // check if the pdfs has already in place, API call
    // if existed, setState for pdfInternal/pdfClient/pdfShared
    return async () => {
      const res = await API.getUserGuideRequest(type);
      if (res) {
        callback({ fileName: res.fileName, contentBlob: res.data });
      }
    };
  }

  useEffect(function checkIfPDFAlreadyExistInServer() {
    fulfullPDFIfExist('Internal', setPdfInternal)();
    fulfullPDFIfExist('Client', setPdfClient)();
    fulfullPDFIfExist('Share', setPdfShared)();
  }, []);

  const onTabChange = useCallback((tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);

  return (
    <div className="manage-module-wrapper use-guide-setting">
      <Tabs defaultActiveKey={defaultTab} type="card" onChange={onTabChange}>
        <TabPane tab="Internal" key="internal">
          <PDFViewControl
            pdf={pdfInternal}
            setPdf={setPdfInternal}
            type="Internal"
          />
        </TabPane>
        <TabPane tab="Client" key="client">
          <PDFViewControl pdf={pdfClient} setPdf={setPdfClient} type="Client" />
        </TabPane>
        <TabPane tab="Shared" key="shared">
          <PDFViewControl pdf={pdfShared} setPdf={setPdfShared} type="Share" />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default UserGuideSetting;
